import { Component } from '@angular/core';
import { EventManagerService } from 'event-manager';
import { WincoEvents } from 'src/app/enums/winco-events..enum';
import { ExerciseService } from 'src/app/services/exercise.service';

/**
 * Componente que se muestra en el modal para activar o desactivar el tracking en los ejercicios
 */
@Component({
  selector: 'app-exercise-tracking',
  templateUrl: './exercise-tracking.component.html',
  styleUrls: ['./exercise-tracking.component.scss']
})
export class ExerciseTrackingComponent
{
  showComponent: boolean = true;

  constructor(private eventManagerService: EventManagerService,
              public exerciseService:ExerciseService)
  {}

  /**
   * Se ejecuta al inicio del componente y reestablece el valor del tracking
   */
  ngOnInit()
  {
    this.exerciseService.trackingCheck = true;
    this.eventManagerService.emitEvent(WincoEvents.TRACKING_CHECK, true);
  }

  /**
   * Guarda el valor del check de tracking en el servicio
   * @param value Valor a pasar del check
   */
  onChange(value: boolean)
  {
    this.exerciseService.trackingCheck = value;
    this.eventManagerService.emitEvent(WincoEvents.TRACKING_CHECK, value);
  }
}
